import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import i18n from "i18next";
import Cookies from "js-cookie";
// import { setCredentials, logOut } from "../../features/auth/authSlice";

const BASE_URL = import.meta.env.VITE_APP_API_URL;

const baseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	mode: "cors",
	sameSite: "None",
	secure: true,
	credentials: "include",
	prepareHeaders: (headers, _builder) => {
		if (!Cookies.get("XSRF-TOKEN")) {
			axios
				.get(`${BASE_URL}/sanctum/csrf-cookie`, {
					withCredentials: true,
					withXSRFToken: true,
				})
				.catch((err) => {
					console.error(err);
				});
		}

		headers.set("X-Requested-With", "XMLHttpRequest");
		// headers.set("Content-Type", "application/json");
		// headers.set("Accept", "application/json");

		const selectedLang = i18n.language;
		headers.set("X-Lang", selectedLang);

		return headers;
	},
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
	let result = await baseQuery(args, api, extraOptions);

	if (result?.error?.status === 401 && args !== "/api/user") {
		window.location.href = "/";
	}
	return result;
};

const apiSlice = createApi({
	// refetchOnFocus: true,
	// refetchOnReconnect: true,
	skipPollingIfUnfocused: true,
	baseQuery: baseQueryWithReauth,
	tagTypes: [
		"AppSettings",
		"Cargos",
		"CompanyCargos",
		"CargosOffers",
		"Branches",
		"CompanyBranches",
		"Stats",
		"CompanyStats",
		"CompanyWeeklyPublicationStats",
		"Recipients",
		"BlackList",
		"Users",
		"UsersChangelog",
		"Companies",
		"AwaitingCompanies",
		"CompaniesContactPersons",
		"CompaniesNotes",
		"CompaniesPaymentInfos",
		"MailingGroups",
		"CarrierCargos",
		"Integrations",
		"CountryCodes",
		"CargoTemplates",
		"LatestCargosParams",
		"IMAPEmails",
		"InfoBar",
		"TransporeonQueue",
	],
	endpoints: (_builder) => ({}),
});

export default apiSlice;

export function providesList(resultsWithIds, tagType) {
	return resultsWithIds
		? [
				{ type: tagType, id: "LIST" },
				...resultsWithIds.map(({ id }) => ({ type: tagType, id })),
		  ]
		: [{ type: tagType, id: "LIST" }];
}
